<template>
  <v-container class="video-container">
    <v-row>
      <v-col cols="12">
        <h1 class="white--text">{{ $t('videoContainer.lastYearTitle') }}</h1>
      </v-col>
      <v-col cols="12" md="9" class="align-center justify-center order-1 order-md-0 d-flex">
        <!--					<v-col cols="12">
                    <v-icon
                        large
                        color="white"
                    >
                      mdi-video-off
                    </v-icon>
                  </v-col>
                  <v-col cols="12">
                    <p style="color: white">{{$t('videoContainer.videoNotAvailable')}}</p>
                  </v-col>-->
        <v-progress-circular
            class="video-loader"
            indeterminate
            color="#ffffff"
        ></v-progress-circular>
        <v-row class="front-overlay">
          <v-col cols="12">
            <iframe
                class="video-wrapper"
                src="https://www.youtube.com/embed/KxQwAmz6iTg?autoplay=1&mute=1&enablejsapi=1&controls=0&VQ=1080&start=1805"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen>
            </iframe>
          </v-col>
          <v-col cols="12">
            <p class="white--text">{{ $t('videoContainer.videoMove') }}</p>
          </v-col>
          <!--							<v-col cols="12">
                          <v-row>
                            <v-col cols="12">
                              <v-btn
                                  color="#EF4758"
                                  dark
                                  @click="$emit('goBack')"
                              >
                                {{$t('general.back')}}
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-col>-->
        </v-row>
      </v-col>
      <v-col cols="12" md="3" class="order-0 order-md-1">
        <v-row>
          <count-down @onExpired="onTimerExpired"/>
        </v-row>
        <v-row class="d-flex align-center justify-center mt-5">
          <gallery-overlay :images-enabled="timerExpired"/>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="full-width">
      <v-col cols="12" md="9">
        <v-btn
            dark
            outlined
            rounded
            @click="goBack"
        >
          {{ $t('general.back') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ImageGallery from "./ImageGallery";
import CountDown from "./CountDown";
import GalleryOverlay from "./GalleryOverlay";

export default {
  name: "VideoContainer",
  components: {GalleryOverlay, ImageGallery, CountDown},
  data() {
    return {
      timerExpired: false
    };
  },
  mounted() {

  },
  methods: {
    goBack() {
      const vm = this;

      vm.$emit('goBack');

      vm.$ga.event({
        eventCategory: 'buttonPress',
        eventAction: 'goBack'
      });
    },
    onTimerExpired() {
      const vm = this;

      vm.timerExpired = true;
      vm.$emit('countdownExpired')

    }
  }
}
</script>

<style scoped>
.video-container {
  text-align: center;
  justify-content: center;
  display: flex;
  align-items: center;
  z-index: 30;
  flex-direction: column;
}

.video-loader {
  position: absolute;
  z-index: 1;
}

.video-wrapper {
  width: 90%;
  min-height: 600px;
  border-radius: 20px;
}

.front-overlay {
  z-index: 2;
}

.full-width {
  width: 100%;
}
</style>
